var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetWrapper',{staticClass:"app-sheet-location-large"},[(_vm.logoImageUrl)?_c('AppSheetRow',[_c('AppSheetBlockWithShareMenu',{attrs:{"share-url":_vm.shareUrl}},[_c('AppSheetPreviewLogo',{attrs:{"logo-image-url":_vm.logoImageUrl}})],1)],1):_vm._e(),_c('AppSheetRow',[_c('AppRichText',{attrs:{"html-content":_vm.htmlContent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }